import { jsx as _jsx } from "react/jsx-runtime";
// this is kept in case we will have to overwrite any other icons
// import { Icons } from 'material-table';
// import ViewColumn from '@mui/icons-material/ViewColumn';
// import SaveAlt from '@mui/icons-material/SaveAlt';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
// import Check from '@mui/icons-material/Check';
// import FilterList from '@mui/icons-material/FilterList';
// import Remove from '@mui/icons-material/Remove';
// import SortArrow from '@mui/icons-material/Sort';
export const tableIcons = {
    // Check: () => <Check />,
    // DetailPanel: () => <ChevronRight />,
    // Export: () => <SaveAlt />,
    // Filter: () => <FilterList />,
    FirstPage: () => _jsx(FirstPage, {}),
    LastPage: () => _jsx(LastPage, {}),
    NextPage: () => _jsx(ChevronRight, {}),
    PreviousPage: () => _jsx(ChevronLeft, {}),
    // ResetSearch: (() => <></>) as any,
    // Search: (() => <></>) as any,
    // SortArrow: () => <SortArrow />,
    // ThirdStateCheck: () => <Remove />,
    // ViewColumn: () => <ViewColumn />,
};
